<template>
  <v-container>
    <v-layout align-space-around justify-center column fill-height id="listing">
      <v-flex xs12 style>
        <v-progress-linear :active="loading" :indeterminate="loading" absolute top color="black"></v-progress-linear>
        <server-side-iterator
          :pagination="pagination"
          :loading="loading"
          v-on:paginate="paginate"
          :grid="{sm2:true, md4:true}"
        >
          <template v-slot:default="item">
            <div class="px-2 my-1">
              <advert-item class="px-0" v-bind="item" @click.self="viewItem" :can_favorite="true">
                <v-btn
                  text
                  color="primary"
                  @click.stop="viewItem(item.uuid)"
                >{{ trans('app.show_details') }}</v-btn>
              </advert-item>
            </div>
          </template>
          <template v-slot:no-data>
            <v-alert class="py-5 my-5" elevation="2">
              <p class="text-center">{{ trans('app.no_favorites_message') }}</p>
              <div class="text-center">
                <v-btn dark color="primary" :to="{name: 'search'}">
                  <v-icon left>mdi-plus</v-icon>
                  <span>{{ trans('app.no_favorites_add') }}</span>
                </v-btn>
              </div>
            </v-alert>
          </template>
        </server-side-iterator>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import _ from "lodash";
import { mapGetters, mapActions, mapState } from "vuex";
import AdvertItem from "../components/AdvertItem";

export default {
  components: {
    "advert-item": AdvertItem
  },
  data: () => ({
    currrent_page: 1,
    per_page: 10,
    fab: false
  }),

  computed: {
    ...mapState("search", {
      query: "query",
      pagination: "pagination"
    }),
    ...mapGetters("search", {
      isLoading: "isLoading",
      paginated_items: "paginated_items",
      items: "items",
      clustersStore: "clusters"
    }),

    loading: function() {
      return this.isLoading("fetch");
    }
  },

  methods: {
    ...mapActions("search", {
      fetch: "fetch",
      setQuery: "setQuery",
      setQueryParam: "setQueryParam",
      loadItems: "loadItems"
    }),

    paginate: function(page) {
      this.$vuetify.goTo(0);
      this.setQuery({ page: page });
      this.fetch();
    }
  },

  mounted: function() {
    this.setQuery({ limit: 15 });
    this.fetch();
  }
};
</script>

<style lang="scss">
</style>